export enum VehicleBody {
  _12_TONNER = '_12_TONNER',
  _18_TONNER = '_18_TONNER',
  _20_FEET_DC_CONTAINER = '_20_FEET_DC_CONTAINER',
  _40_FEET_DC_CONTAINER = '_40_FEET_DC_CONTAINER',
  _45_HQ_CONTAINER = '_45_HQ_CONTAINER',
  _7_5_TONNER = '_7_5_TONNER',
  BOX = 'BOX',
  FLATBED = 'FLATBED',
  GERMAN_FLATBED = 'GERMAN_FLATBED',
  MEGA = 'MEGA',
  OPEN_TOP_TARPAULIN = 'OPEN_TOP_TARPAULIN',
  POLAND_SPRINTER_3_5_T = 'POLAND_SPRINTER_3_5_T',
  REFRIGERATED = 'REFRIGERATED',
  REFRIGERATED_TRAILER = 'REFRIGERATED_TRAILER',
  REFRIGERATED_TRUCK = 'REFRIGERATED_TRUCK',
  ROADTRAIN = 'ROADTRAIN',
  SHORT_TRAILER = 'SHORT_TRAILER',
  STEEL = 'STEEL',
  SWAP_BODY = 'SWAP_BODY',
  SWAP_CONTAINER_AND_BRIDGES = 'SWAP_CONTAINER_AND_BRIDGES',
  TAUTLINER = 'TAUTLINER',
  TAUTLINER_SLIDING_ROOF = 'TAUTLINER_SLIDING_ROOF',
  TRANSPORTER_OR_VAN = 'TRANSPORTER_OR_VAN',
}
